import type { ComponentProps } from 'react'

import { TripChatMobileOverlayProvider } from '../mobile/TripChatMobileOverlayContext'
import { TripListPricingProvider } from '../contexts/TripListPricingContext'
import TripChatMobileSurfaceContent from './TripChatMobileSurfaceContent'

function TripChatMobileSurface(props: ComponentProps<typeof TripChatMobileSurfaceContent>) {
  return (
    <TripListPricingProvider>
      <TripChatMobileOverlayProvider>
        <TripChatMobileSurfaceContent {...props} />
      </TripChatMobileOverlayProvider>
    </TripListPricingProvider>
  )
}

export type TripChatMobileSurfaceProps = ComponentProps<typeof TripChatMobileSurface>

export default TripChatMobileSurface
